import React from "react";
import styled from "styled-components";
import { TitleHeader } from "../../TitleHeader";

import { useDataContex } from "../../../hooks/Context/PatientProvider";
import { colors } from "../../../utils/theme";

import Icon1 from "../../../assets/icons/iconFaceook.svg";
import Icon2 from "../../../assets/icons/iconInsta.svg";
import Icon3 from "../../../assets/icons/iconWhat.svg";
import { useLocation, useNavigate } from "react-router-dom";
import { SumarySchedComponentContinuidad } from "./Components/SumarySchedComponent";
import { SectionProgrammedContinuidad } from "./Components/ SectionProgrammed";
import { ReminderComponentsContinuidad } from "./Components/ ReminderComponents";

const Container = styled.div`
  width: 100%;
  margin-top: 2rem;
`;

const Session = styled.div`
  width: 90%;
  background-color: #f9f9f9;
  margin: 0 auto;
  border-radius: 10px;
  box-shadow: 1px 1px 5px 1px #00000029;
`;

const ContainerIcons = styled.div`
  display: flex;
  width: 80%;
  margin: 0 auto;
  justify-content: center;

  article {
    width: 10rem;
    height: 10rem;
    display: flex;
    justify-content: center;
    align-items: center;

    .faceboook {
      width: 80px;
      height: 80px;
    }
    .what {
      width: 130px;
      height: 130px;
    }
  }
`;
const Button = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 2rem;

  button {
    width: 20%;
    display: block;
    padding: 0.7rem;
    border: none;
    border-radius: 30px;
    color: ${colors.blanco};
    background-color: ${colors.azul};
    margin-bottom: 2rem;
    font-weight: bold;
    @media (max-width: 1440px) {
      width: 30%;
    }
    @media (max-width: 1024px) {
      width: 40%;
    }
    @media (max-width: 768px) {
      width: 50%;
    }
    @media (max-width: 600px) {
      width: 80%;
    }
    @media (max-width: 350px) {
      font-size: 0.8rem;
    }
  }
`;

export const ResumenCitaContinuidad = () => {
  const navigate = useNavigate();
  const location = useLocation();

  // if (!location.state) {
  //   return <div>no hay datos</div>;
  // }

  const { Paciente, fechaActualUTC } = location.state;
  const PacienteData = Paciente;
  const FechaSeleccionada = fechaActualUTC;



  function handleClick() {
    navigate("/");
  }
  // if () {
  //   window.history.replaceState(null, "", "/PacienteNuevo");
  //   window.location.reload();
  //   return;
  // }
  return (
    <Container>
      <TitleHeader />
      <Session>
        <SumarySchedComponentContinuidad paciente={PacienteData} />
        <SectionProgrammedContinuidad fecha={FechaSeleccionada} />
        <ReminderComponentsContinuidad />
        <Button>
          <button onClick={handleClick}>Volver Al Inicio</button>
        </Button>
      </Session>

      <ContainerIcons>
        <article>
          {" "}
          <img className="faceboook" src={Icon1} alt="" />{" "}
        </article>
        <article>
          {" "}
          <img className="insta" src={Icon2} alt="" />{" "}
        </article>
        <article>
          {" "}
          <img className="what" src={Icon3} alt="" />{" "}
        </article>
      </ContainerIcons>
    </Container>
  );
};
